import '../common/debounce'
import setFullWidthElementCSSVariables from './metal_store/set_full_width_element_css_variables'
import { updateQuantitiesFromBasket, prepareBasketPage } from './metal_store/basket'
import tradeCounterCheckout from '../common/trade_counter_checkout'

function pageLoad () {
  setFullWidthElementCSSVariables()

  // Basket
  prepareBasketPage()

  tradeCounterCheckout()
}

function documentReady (eventHandler) {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    eventHandler()
  } else {
    document.addEventListener('DOMContentLoaded', eventHandler)
  }
}

window.updateQuantitiesFromBasket = updateQuantitiesFromBasket

documentReady(pageLoad)

documentReady(updateQuantitiesFromBasket)

window.addEventListener('visibilitychange', () => {
  if (!document.hidden) {
    updateQuantitiesFromBasket()
  }
})
